import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';

import getSpaceIdFromUrl from './utils/getSpaceIdFromUrl';
import {
  StyledPaper,
  StyledLink,
  StyledList,
  StyledListItem,
  DisabledLink,
} from './SideBar.styled';

const SideBar = ({ location }) => {
  const spaceId = getSpaceIdFromUrl(location);

  return (
    <StyledPaper elevation={0} aria-label="sidebar navigation">
      <StyledList>
        <StyledListItem>
          <StyledLink exact to={`/${spaceId}`} activeClassName="selected">
            Assignments
          </StyledLink>
        </StyledListItem>
        <StyledListItem>
          <StyledLink
            exact
            to={`/${spaceId}/students`}
            activeClassName="selected"
          >
            Students
          </StyledLink>
        </StyledListItem>
        <StyledListItem>
          <Tooltip title="🚧 Coming soon!" position="left" spacing={4}>
            <DisabledLink>Engagement Insights</DisabledLink>
          </Tooltip>
        </StyledListItem>
      </StyledList>
    </StyledPaper>
  );
};

SideBar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(SideBar);
